export enum SourceFilterOptions {
  PRIVATE = 'PRIVATE',

  MY_ORG = 'MY_ORG',
  ORG = 'ORG',

  MY_MARKETPLACE = 'MY_MARKETPLACE',
  ORG_MARKETPLACE = 'ORG_MARKETPLACE',
  My_ORG_MARKETPLACE = 'MY_ORG_MARKETPLACE',
  PLATFORM = 'PLATFORM',
  ARCHIVED = 'ARCHIVED',
}

export enum ContentTypeOptions {
  EXERCISE = 'EXERCISE',
  WORKOUT = 'WORKOUT',
  PROGRAM = 'PROGRAM',
  MEAL = 'MEAL',
  NUTRITION_PLAN = 'NUTRITION_PLAN',
  EPISODE = 'EPISODE',
  MODULE = 'MODULE',
  COURSE = 'COURSE',
}
